
import {defineComponent,ref, computed, reactive} from "vue";
import useVuelidate from "@vuelidate/core";
import { required,  email, helpers} from "@vuelidate/validators";
import Reset_datos_user from "@/services/reset_pswd/reset_datos_user.service";
import spinner from "@/components/master/spinner.vue";
//import vueRecaptcha from 'vue3-recaptcha2';
//import Captcha from '@/services/captcha/captcha';
//CaptchaCanvas
import CaptchaCanvas from '../captcha/CaptchaCanvas.vue'
export default defineComponent({
    components: {
        spinner, CaptchaCanvas //vueRecaptcha
    },
    setup() {
        const mostrar_error = ref(false);
        const msg = ref({
            severity: "error",
            content: ""
        });
        const enviar_mail = ref(true);
        const cargar = ref(false);
        const servReset = new Reset_datos_user();
        //variables para valaidacion de login
        const submitted = ref(false);
        const state = reactive({
                  mail: "",
             });
        // recaptcha
        const recaptchaPublicKey = ref(null);
        const recaptchaSecretKey = ref(null);
        const captchaValida = ref(false);
        const captchaInvalid = ref(false)

        //servicio
       // const servCaptcha    = ref(new Captcha)  

        const rules = computed(() => ({
            mail: {
                required: helpers.withMessage(
                    "La dirección de correo electrónico es requerida.",
                    required
                ),
                email: helpers.withMessage("El formato no es válido.", email),
            },
        }));

        const v$ = useVuelidate(rules, state);

        return {
            cargar,
            servReset,
            mostrar_error,
            msg,
            enviar_mail,
            state,
            v$,
            submitted, // variables de validador login
            recaptchaPublicKey,
						recaptchaSecretKey, //servCaptcha,
            captchaValida,
            captchaInvalid
        };
    },
    methods: {
        async submit_correo() {
            try {
                this.v$.$validate();
								this.validarCaptcha();
								if (!this.captchaValida) {
										this.captchaRequerida = true;
										return;
								}
                this.submitted = true;
                if (this.v$.$error) {
                    return;
                } else {
                   if(this.captchaValida){
                    this.captchaInvalid=false
                    this.cargar = true;
                    const resultado: any = await this.servReset.Reset_contrasenia_user(
                        this.state.mail
                    );
                    if (resultado.success) {
                        this.$toast.add({
                            severity: "success",
                            summary: "Éxito",
                            detail: resultado.message,
                            life: 3000,
                        });
                        this.enviar_mail = false;
                        this.cargar = false;
                    } else {
												this.$refs.captchaRef?.generate();	
                        if (resultado.errors.length > 0) {
                            resultado.errors.forEach((element: any) => {
                                this.$toast.add({
                                    severity: "warn",
                                    summary: "Advertencia: " + resultado.message,
                                    detail: element.message,
                                    life: 3000,
                                });
                                
                            });
                        } else {
                            this.$toast.add({
                                severity: "warn",
                                summary: "Advertencia",
                                detail: resultado.message,
                                life: 3000,
                            });                          
                        }
                          this.cargar = false;
                    }
                }else{
                    this.captchaInvalid = true 
                }
            }
            } catch (error) {
                this.mostrar_error = true;
                this.msg.content = error;
                this.cargar = false;
								this.$refs.captchaRef?.generate();	
            }
        },

				validarCaptcha() {
						// Validar CaptchaCanvas
						const userInput = this.$refs.captchaRef?.getUserInput() || '';
						const currentCode = this.$refs.captchaRef?.getCurrentCode() || '';
						const isValid = userInput.trim() === currentCode;
						this.captchaValida = isValid;
						//console.log('Validando CaptchaCanvas:', { userInput, currentCode, isValid });
						if (!isValid) {
								this.$refs.captchaRef?.generate();
								this.captchaRequerida = false;
								this.$toast.add({ severity: 'warn', summary: 'Advertencia', detail: 'El código de validación es incorrecto. Intenta de nuevo.', life: 5000 })
								return;
						}
				},

        evalRespuestaAPI(response) {
            if (response.success) {
                if (response.data.length == 0) {
                    this.$toast.add({
                        severity: "success",
                        summary: "Información",
                        detail: response.message,
                        life: 3000,
                    });
                }
            } else {
                if (response.errors.length > 0) {
                    response.errors.forEach((element) => {
                        this.$toast.add({
                            severity: "warn",
                            summary: "Advertencia: " + response.message,
                            detail: element.message,
                            life: 3000,
                        });
                    });
                } else {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Advertencia",
                        detail: response.message,
                        life: 3000,
                    });
                }
            }
            return response.data;
        },
				//onCaptchaVerified(response) {
				//		const params = {
				//				"secretKey": this.recaptchaSecretKey,
				//				"recaptcha": response
				//		}

				//		this.servCaptcha.obtenerVerificacionCaptcha(params).then((response) => {
				//				this.captchaValida = response.data.success;

				//				if (!this.captchaValida) {
				//						this.mostrar_error = true;
				//						this.msg.content = response.data.errorCodes;
				//				} else {
				//						this.captchaInvalid = false
				//				}
				//		})
				//				.catch(error => {
				//						this.mostrar_error = true;
				//						this.msg.content = error;
				//				})
				//},
    //    onCaptchaExpired(){
    //        this.$refs.vueRecaptcha.reset();
    //        this.captchaValida = false;
    //    },
        
    //    getKeysRecaptcha(){
    //        this.servCaptcha.GetKeysRecaptcha()
    //        .then((response)=>{
    //            this.evalRespuestaAPI(response.data);

    //            if (response.data.success){
    //                this.recaptchaPublicKey = response.data.data.recaptchaPublicKey
    //                this.recaptchaSecretKey = response.data.data.recaptchaSecretKey                  
    //            }
    //        })
    //    }
    },
    beforeMount(){
        Promise.all([        
           // this.getKeysRecaptcha()           
        ]);  
     },
});
